<template>
  <div class="checkboxes-input">
    <fieldset class="form-group">
      <div class="row">
        <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
          {{ options.label }}
          <span v-if="options.required" class="required">*</span>
        </label>
        <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
          <div class="card">
            <ul class="list-group list-group-flush" v-for="(object, index) in options.objects" :key="index">
              <li class="list-group-control">
                <label class="custom-control material-checkbox">
                  <input type="checkbox" class="material-control-input"
                    :value="object.uuid"
                    :id="object.uuid"
                    :checked="value.includes(object.uuid)"
                    :name="options.name + '[]'"
                    @change="validate($event)">
                  <span class="material-control-indicator"></span>
                  <span class="material-control-description">
                    <img v-if="options.icon && object[options.icon]" class="nav-item-img" :src="S3_BUCKET_URL + object[options.icon].objectKey">
                    <span v-html="object[options.objectName]"></span>
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import {
  S3_BUCKET_URL,
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CheckboxesInput',
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default () {
        return {
          label: '',
          name: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      S3_BUCKET_URL
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  methods: {
    validate (event = false) {
      let value = this.value
      if (event) {
        if (value.includes(event.target.value)) {
          value = value.filter((el) => event.target.value !== el)
        } else {
          value = [ ...value, event.target.value ]
        }
      }
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CheckboxesInput.vue